import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from '@src/store/store';
import AppContent from './AppContent';
import AuthProvider from '@src/auth/AuthProvider';
import { ThemeProvider } from '@src/components/ui';
import { customTheme } from './theme/customTheme';

const App = () => {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <ThemeProvider initialTheme={customTheme}>
                            <AppContent />
                        </ThemeProvider>
                    </PersistGate>
                </Provider>
            </AuthProvider>
        </BrowserRouter>
    );
};

export default App;
